import { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { convertResponseToOptions } from '../../../utils/utils';

import { getCLAOptions } from 'RestAPIs/admin';

import { ControlledSelect, showSnackbar } from 'components/shared';

type Props = {
  control: Control<any>;
  isEdit?: boolean;
  setValue?;
};

export function MaxCLACodeGroupSelect({ control }: Props) {
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ['maxCLAGroupOpts'],
    queryFn: async () => {
      const { data } = await getCLAOptions();
      return data;
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('fetchError')
      });
    }
  });

  const options = useMemo(() => {
    return convertResponseToOptions(data);
  }, [data]);

  return (
    <ControlledSelect
      name={'claId'}
      options={options}
      control={control}
      variant="outlined"
      label={t('max_buh.grid.claId')}
    />
  );
}

export function MaxCLATypeGroupSelect({ control }: Props) {
  const { t } = useTranslation();

  const options = [
    {
      value: 'MAX_BUH',
      label: t('max_buh.grid.claType.max_buh')
    },
    {
      value: 'MAX_SA',
      label: t('max_buh.grid.claType.max_sleeping_allowance')
    }
  ];
  return (
    <ControlledSelect
      name="type"
      options={options}
      control={control}
      variant="outlined"
      label={t('max_buh.grid.type')}
    />
  );
}
